import * as React from 'react';
import SUIGaugeMarker from '@splunk/react-icons/enterprise/GaugeMarker';

const MarkerGauge = (
    // eslint-disable-next-line no-undef
    props: Omit<React.ComponentProps<typeof SUIGaugeMarker>, 'screenReaderText'>
): React.ReactElement<SVGElement> => <SUIGaugeMarker {...props} screenReaderText={null} />;

export default MarkerGauge;
